import { c as e } from "../../../../index.esm-BeDSGXP5.js";
import { css as s } from "styled-components";
const t = (o) => o.componentColors.search, l = {
  input: {
    clearIcon: ({ theme: o, variant: r }) => /* @__PURE__ */ s([
      "color:",
      ";"
    ], t(o).input[r].clearIcon),
    searchIcon: ({ variant: o, theme: r }) => /* @__PURE__ */ s([
      "color:",
      ";pointer-events:none;user-select:none;"
    ], t(r).input[o].searchIcon),
    base: ({ theme: o, colorVariant: r }) => /* @__PURE__ */ s([
      "width:100%;border:0;margin-left:-",
      ";padding-left:",
      ";margin-right:-",
      ";padding-right:",
      ";margin-top:0;color:",
      ";border-bottom:0.2rem solid ",
      ";background-color:transparent;border-bottom-left-radius:0;border-bottom-right-radius:0;&::placeholder{color:",
      ";}&::-ms-input-placeholder{color:",
      ";}&:focus{color:",
      ";border-color:",
      ";}"
    ], o.space.md, o.space.lg, o.space.md, o.space.lg, t(o).input[r].text, t(o).input[r].border, t(o).input[r].placeholder, t(o).input[r].placeholder, t(o).input[r].text, t(o).input[r].borderFocus)
  },
  results: {
    wrapper: ({ theme: o }) => /* @__PURE__ */ s([
      "",
      ""
    ], e({
      backgroundColor: t(o).results.wrapper,
      padding: "sm"
    })),
    list: ({ theme: o }) => /* @__PURE__ */ s([
      "",
      ""
    ], o.resets.space),
    listItem: ({ theme: o }) => /* @__PURE__ */ s([
      "",
      " ",
      " &:first-child{padding-top:0;}&:last-child{border-bottom:none;padding-bottom:0;}"
    ], o.resets.list.item, e({
      borderBottomWidth: "0.2rem",
      borderBottomStyle: "solid",
      borderBottomColor: t(o).results.border,
      paddingY: "sm"
    }))
  }
};
export {
  l as default
};
